export const DRAWER_WIDTH = 240;

export const ACTIVE_ACCOUNT_KEY = 'backspace-active-account'; // localStorage key for active account
